import { render } from "./editUser.vue?vue&type=template&id=f60b6f04&scoped=true"
import script from "./editUser.vue?vue&type=script&lang=js"
export * from "./editUser.vue?vue&type=script&lang=js"

import "./editUser.vue?vue&type=style&index=0&id=f60b6f04&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60b6f04"]])

export default __exports__